
import React from 'react';
import NotificationItem from './NotificationItem';
import EmptyNotifications from './EmptyNotifications';
import { NotificationListProps } from '@/types/notifications-types';

/**
 * Component to display a list of notifications
 */
const NotificationList: React.FC<NotificationListProps> = ({ 
  notifications, 
  onRemoveNotification,
  onMarkAsRead
}) => {
  if (notifications.length === 0) {
    return <EmptyNotifications />;
  }

  return (
    <div 
      className="space-y-4" 
      data-test-id="notification-list"
    >
      {notifications.map(notification => (
        <NotificationItem 
          key={notification.id} 
          notification={notification}
          onRemoveNotification={onRemoveNotification}
          onMarkAsRead={onMarkAsRead}
        />
      ))}
    </div>
  );
};

export default NotificationList;
